<template>
  <div class="mt-auto">
    <div v-if="pltService" class="d-md-flex d-none justify-content-center">
      <div class="brand-section-body-item">
        <div class="brand-section-body-item_logo">
          <img
            :src="platformLogos[pltService]"
            :alt="`${pltService} logo`"
            style="width: 55px; height: 55px"
          />
        </div>
        <div class="brand-section-body-item_intro">
          <span class="font-weight-bold" style="font-size: 1.1em;">
            {{ $t(`${pltService}_name`) }}
          </span>
          {{ $t(`${pltService}_slogan`) }}
        </div>
      </div>
    </div>
    <div
      :class="[
        'mt-3 mt-md-auto mx-auto w-100 border p-3 p-md-4',
        { 'text-right rtl': $i18n.locale !== 'en' },
      ]"
      style="max-width: 500px"
    >
      <div class="d-flex justify-content-center align-items-center">
        <div
          v-if="pltService && platformLogos[pltService]"
          class="brand-section-body-item_logo d-md-none ml-3"
          style="padding: 5px"
        >
          <img :src="platformLogos[pltService]" :alt="`${pltService} logo`" />
        </div>
        <h1 class="mb-4 text-center" style="color: #555">
          <span class="form-header" style="font-size: 55%">
            <span>
              {{ $t("signup") }}
            </span>
            <span
              v-if="pltService && platformLogos[pltService]"
              class="d-md-none"
              style="font-weight: normal"
            >
              در {{ $t(`${pltService}_name`) }}
            </span>
          </span>
        </h1>
      </div>
      <form
        ref="form"
        class="d-flex justify-content-center flex-column"
        method="POST"
        autocomplete="off"
        :action="urls.signup + queryParams"
      >
        <a
          :href="urls.googleLogin"
          class="google_btn mb-1"
          data-gtm-name="login_google_register"
        >
          <div class="label">{{ $t("google_signup") }}</div>
          <div class="icon-container">
            <span class="icon"></span>
          </div>
        </a>
        <a
          v-if="$i18n.locale !== 'fa'"
          :href="urls.facebookLogin"
          class="facebook_btn mb-1 mt-3"
        >
          <div class="label">{{ $t("facebook_signup") }}</div>
          <div class="icon-container">
            <span class="icon"></span>
          </div>
        </a>
        <div class="divider mb-1">
          <div class="text text-center">{{ $t("or") }}</div>
        </div>
        <div class="d-flex flex-wrap mx-n1">
          <field-input
            v-model="first_name"
            class="px-sm-1 w-sm-50 w-100 mb-3"
            ref="first_name"
            type="text"
            name="first_name"
            autocomplete-off
            :label="$t('first_name')"
            no-trim
            :server-error="serverError.first_name"
            :rules="[
              vRules.required($t('validation_message.firstName_is_required')),
            ]"
            data-gtm-name="login_register_name"
          />
          <field-input
            v-model="last_name"
            class="px-sm-1 w-sm-50 w-100 mb-3"
            ref="last_name"
            type="text"
            name="last_name"
            autocomplete-off
            :label="$t('last_name')"
            no-trim
            :server-error="serverError.last_name"
            :rules="[
              vRules.required($t('validation_message.lastName_is_required')),
            ]"
            data-gtm-name="login_register_last_name"
          />
          <field-input
            v-model="email"
            class="px-sm-1 w-sm-50 w-100 mb-3"
            ref="email"
            type="text"
            name="email"
            :label="$t('email')"
            autocomplete-off
            input-class="ltr"
            :server-error="serverError.email"
            :rules="[
              vRules.required($t('validation_message.email_is_required')),
              vRules.email(),
            ]"
            data-gtm-name="login_register_email"
          />
          <field-input
            v-model="phone"
            class="px-sm-1 w-sm-50 w-100 mb-3"
            ref="phone"
            type="tel"
            name="phone"
            :label="$t('mobile_number')"
            autocomplete-off
            input-class="ltr"
            number
            :server-error="serverError.phone"
            :rules="[
              vRules.required($t('validation_message.phone_is_required')),
              vRules.phone(),
            ]"
            data-gtm-name="login_register_phone"
          />
          <field-input
            v-model="password1"
            class="px-sm-1 w-sm-50 w-100 mb-3"
            id="password1_input"
            ref="password1"
            type="password"
            name="password1"
            :label="$t('password')"
            autocomplete-off
            input-class="ltr"
            :server-error="serverError.password1"
            :rules="[
              vRules.required($t('validation_message.password_is_required')),
              vRules.password(),
            ]"
            data-gtm-name="login_register_password"
          />
          <field-input
            v-model="password2"
            class="px-sm-1 w-sm-50 w-100 mb-3"
            id="password2_input"
            ref="password2"
            type="password"
            name="password2"
            autocomplete-off
            :label="$t('password_repeat')"
            input-class="ltr"
            :server-error="serverError.password2"
            :rules="[
              vRules.required(
                $t('validation_message.password_repeat_is_required')
              ),
              vRules.password_repeat(password1),
            ]"
            data-gtm-name="login_register_repeat_password"
          />
        </div>

        <input type="hidden" name="csrfmiddlewaretoken" :value="csrfToken" />

        <input
          v-if="redirectFieldValue"
          type="hidden"
          :name="redirectFieldName"
          :value="redirectFieldValue"
        />

        <div
          v-if="serverError.nonFieldErrors"
          class="mt-0 error-text text-center mb-4"
        >
          {{ serverError.nonFieldErrors }}
        </div>
        <button
          class="auth-btn btn btn-primary my-2"
          type="submit"
          data-gtm-name="login_register_register"
        >
          {{ $t("signup") }}
        </button>
        <div
          v-if="$i18n.locale === 'fa'"
          class="policy mb-4 text-right rtl"
          style="color: #444"
        >
          با ثبت نام در یکتانت ، شما با
          <a
            href="https://accounts-cdn.yektanet.com/static/terms/privacy-policy.pdf"
            target="_blank"
            class="link"
            data-gtm-name="login_google_privacy"
          >
            شرایط رازداری و حفظ حریم خصوصی
          </a>
          و
          <a
            href="https://accounts-cdn.yektanet.com/static/terms/terms-of-services.pdf"
            target="_blank"
            class="link"
            data-gtm-name="login_google_terms_of_service"
          >
            شرایط استفاده از خدمات
          </a>
          موافقت می‌کنید.
        </div>
        <div v-else class="policy mb-4" style="color: #444">
          By clicking Sign Up, you agree to our
          <a
            href="https://accounts-cdn.yektanet.com/static/terms/privacy-policy.pdf"
            target="_blank"
            class="link"
          >
            Terms
          </a>
          and
          <a
            href="https://accounts-cdn.yektanet.com/static/terms/terms-of-services.pdf"
            target="_blank"
            class="link"
          >
            Data Policy
          </a>
          . You may receive SMS Notifications from us and can opt out any time.
        </div>
        <div>
          <span style="color: #444">{{ $t("already_have_an_account") }}</span>
          <a
            :href="loginUrl"
            class="link"
            data-gtm-name="login_register_enter_account"
            >{{ $t("login_to_account") }}</a
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { getParam } from "~/utils";

import FieldInput from "~/components/FieldInput.vue";

export default {
  components: { FieldInput },
  data: () => ({
    pltService: "",
    ...serverData,
    platformLogos,
  }),
  computed: {
    loginUrl() {
      return this.urls.login + window.location.search;
    },
    queryParams() {
      return window.location.href.split("?")[1]
        ? "?" + window.location.href.split("?")[1]
        : "";
    },
  },
  mounted() {
    this.pltService = getParam("plt");

    this.$refs.first_name.focus();
    this.$refs.form.addEventListener("submit", (e) => {
      const validations = [
        this.$refs.first_name.validate(),
        this.$refs.last_name.validate(),
        this.$refs.phone.validate(),
        this.$refs.email.validate(),
        this.$refs.password1.validate(),
        this.$refs.password2.validate(),
      ];
      if (
        !validations[0] ||
        !validations[1] ||
        !validations[2] ||
        !validations[3] ||
        !validations[4] ||
        !validations[5]
      ) {
        e.preventDefault();
      } else {
        if (/^9\d{9}$/.test(this.phone)) {
          this.phone = "0" + this.phone;
        } else if (/^\+989\d{9}$/.test(this.phone)) {
          this.phone = this.phone.replace("+98", "0");
        }
      }
    });
  },
};
</script>

<style scoped>
@media (min-width: 576px) {
  .w-sm-50 {
    width: 50% !important;
  }
}
</style>
